/**
 * Global application constants
 */

/** Meitre Google Analytics 4 measurement ID */
export const MEITRE_GA_ID = 'G-Y1G6VBEVWT';

/** Meitre landing page URL for redirects */
export const MEITRE_URL = import.meta.env.DEV
  ? 'http://localhost:8080'
  : 'https://meitre.com';

/** Meitre for restaurants — target of the "powered by Meitre" attribution link */
export const MEITRE_PRO_URL = 'https://pro.meitre.com/';

/** @deprecated Use getAuthDomain() from @core/config/authDomain instead */
export const AUTH_SUBDOMAIN = 'auth.meitre.com';

/** Default party sizes to show in booking */
export const DEFAULT_PARTY_SIZES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/** Maximum party size for online booking */
export const MAX_PARTY_SIZE = 20;

/** Default booking window in days */
export const DEFAULT_BOOKING_WINDOW_DAYS = 30;

/** Mobile breakpoint in pixels */
export const MOBILE_BREAKPOINT = 768;

/** Session storage keys */
export const STORAGE_KEYS = {
  AUTH_STATE: 'meitre_auth_state',
  BOOKING_STATE: 'meitre_booking_state',
  REDIRECT_STATE: 'meitre_redirect_state',
} as const;

/** API endpoints */
export const API_ENDPOINTS = {
  RESTAURANT_INFO: '/api/get-restaurant-info-subdomain',
  AVAILABILITY: '/api/availability',
  CREATE_BOOKING: '/api/bookings',
  PASSWORDLESS_SEND: '/auth/passwordless/send',
  PASSWORDLESS_VERIFY: '/auth/passwordless/verify',
  GET_USER_INFO: '/api/get-user-info',
} as const;
